export default __webpack_public_path__ + "static/media/Welcome-gif-M-3B.c54b9a82.png";